import React, { useState, useRef, useEffect } from "react";
import { db } from "../firebase/firebase-config";
import { storage } from "../firebase/firebase-config"; // Assuming you export storage from firebase-config
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebase-config"; // Importing auth if it's exported from your firebase-config
import "../styles/AddDogForm.css";
import { Link } from "react-router-dom";
import LogoSVG from "../hooks/LogoSVG";

const AddDogForm = () => {
    const [name, setName] = useState("");
    const [age, setAge] = useState("");
    const [breed, setBreed] = useState("");
    const [photo, setPhoto] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneNumber2, setPhoneNumber2] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [imagePreviewUrl, setImagePreviewUrl] = useState("");
    const [description, setDescription] = useState("");
    const [gender, setGender] = useState("Male");
    const [isFriendlyWithDogs, setIsFriendlyWithDogs] = useState("Yes");
    const [isFriendlyWithKids, setIsFriendlyWithKids] = useState("Yes");
    const [spayedNeutered, setSpayedNeutered] = useState(false);
    const [rabiesShot, setRabiesShot] = useState(false);
    const [microchipped, setMicrochipped] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!photo) {
            alert("Please upload a photo of the dog.");
            return;
        }

        // Get the current user from Firebase Authentication
        const user = auth.currentUser;
        if (!user) {
            alert("No authenticated user. Please log in.");
            return;
        }

        try {
            // First upload the photo
            setIsSubmitted(!isSubmitted);
            const photoRef = ref(storage, `dogs/${user.uid}/${photo.name}`); // Save photo under user's directory
            const snapshot = await uploadBytes(photoRef, photo);
            const photoUrl = await getDownloadURL(snapshot.ref);

            // Then store dog data including photo URL and owner ID
            const docRef = await addDoc(collection(db, "dogs"), {
                name,
                age,
                breed,
                photoUrl,
                description,
                phoneNumber,
                phoneNumber2,
                email,
                address,
                gender,
                isFriendlyWithDogs,
                isFriendlyWithKids,
                spayedNeutered,
                rabiesShot,
                microchipped,
                ownerId: user.uid, // Store user ID with dog data
            });
            alert("Dog added successfully!");
            navigate(`/generate-qr/${docRef.id}`);
        } catch (error) {
            console.error("Error adding document: ", error);
            alert("Failed to add dog. Please try again.");
        }
    };

    const handlePhotoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPhoto(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreviewUrl(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, "");
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
            3,
            6
        )} - ${phoneNumber.slice(6, 10)}`;
    };

    const handleNumberChange = (event, setPhoneNumber) => {
        const formattedPhoneNumber = formatPhoneNumber(event.target.value);
        setPhoneNumber(formattedPhoneNumber);
    };

    const textareaRef = useRef(null);

    useEffect(() => {
        adjustTextareaHeight();
    }, [description]);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
    };

    return (
        <>
            {isSubmitted ? (
                <div className="LoadingContainer">
                    <LogoSVG />
                    <h2>Loading...</h2>
                </div>
            ) : (
                <div className="mainContainer">
                    <div className="cancel">
                        <Link to="/home">Cancel</Link>
                    </div>
                    <form onSubmit={handleSubmit} className="addDogForm">
                        <label htmlFor="dogPhoto">Upload photo of dog</label>
                        <input
                            type="file"
                            onChange={handlePhotoChange}
                            accept="image/*"
                            id="dogPhoto"
                        />
                        {imagePreviewUrl && (
                            <img
                                src={imagePreviewUrl}
                                alt="Preview"
                                style={{ width: "100px", height: "100px" }}
                            />
                        )}
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Dog's Name"
                            required
                        />
                        <input
                            type="number"
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                            placeholder="Dog's Age"
                            required
                        />
                        <input
                            type="text"
                            value={breed}
                            onChange={(e) => setBreed(e.target.value)}
                            placeholder="Dog's Breed"
                            required
                        />
                        <select
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                            required
                            className="genders"
                        >
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                        <textarea
                            ref={textareaRef}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Medical issues? No pet zones? Allergies? Put N/A if none"
                            required
                            style={{
                                width: "90%",
                                padding: "10px",
                                resize: "none",
                                overflow: "hidden",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                border: "1px solid lightgrey",
                                borderRadius: "5px",
                            }}
                        />
                        <input
                            type="tel"
                            value={phoneNumber}
                            onChange={(e) =>
                                handleNumberChange(e, setPhoneNumber)
                            }
                            placeholder="Primary Phone Number"
                            pattern="\(\d{3}\) \d{3} - \d{4}"
                            title="Enter a phone number in the format: (123) 456 - 7890"
                            required
                        />
                        <input
                            type="tel"
                            value={phoneNumber2}
                            onChange={(e) =>
                                handleNumberChange(e, setPhoneNumber2)
                            }
                            placeholder="Secondary Phone Number"
                            pattern="\(\d{3}\) \d{3} - \d{4}"
                            title="Enter a phone number in the format: (123) 456 - 7890"
                        />
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Email Address"
                        />
                        <input
                            type="address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="(Optional) Address, City, State, Zip"
                        />
                        <div className="optionalDescriptionContainer">
                            <p>Optional</p>
                            <select
                                value={isFriendlyWithDogs}
                                onChange={(e) =>
                                    setIsFriendlyWithDogs(e.target.value)
                                }
                                className="genders"
                            >
                                <option value="Yes">
                                    Friendly with other dogs
                                </option>
                                <option value="No">
                                    Not friendly with other dogs
                                </option>
                            </select>
                            <select
                                value={isFriendlyWithKids}
                                onChange={(e) =>
                                    setIsFriendlyWithKids(e.target.value)
                                }
                                className="genders"
                            >
                                <option value="Yes">Friendly with kids</option>
                                <option value="No">
                                    Not friendly with kids
                                </option>
                            </select>
                            <div className="optionalDescriptions">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="spayedNeutered"
                                        checked={spayedNeutered}
                                        onChange={() =>
                                            setSpayedNeutered(!spayedNeutered)
                                        }
                                    />
                                    Spayed / neutered
                                </label>
                                <label>
                                    <input
                                        type="checkbox"
                                        name="rabiesShot"
                                        checked={rabiesShot}
                                        onChange={() =>
                                            setRabiesShot(!rabiesShot)
                                        }
                                    />
                                    Rabies shot
                                </label>
                                <label>
                                    <input
                                        type="checkbox"
                                        name="microchipped"
                                        checked={microchipped}
                                        onChange={() =>
                                            setMicrochipped(!microchipped)
                                        }
                                    />
                                    Microchipped
                                </label>
                            </div>
                        </div>
                        <button type="submit">Add Dog</button>
                    </form>
                </div>
            )}
        </>
    );
};

export default AddDogForm;
